var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCheck = function SvgCheck(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28.7081 9.70745L12.7081 25.7074C12.6152 25.8004 12.5049 25.8742 12.3835 25.9245C12.2621 25.9748 12.132 26.0007 12.0006 26.0007C11.8691 26.0007 11.739 25.9748 11.6176 25.9245C11.4962 25.8742 11.3859 25.8004 11.2931 25.7074L4.29306 18.7074C4.10542 18.5198 4 18.2653 4 17.9999C4 17.7346 4.10542 17.4801 4.29306 17.2924C4.4807 17.1048 4.73519 16.9994 5.00056 16.9994C5.26592 16.9994 5.52042 17.1048 5.70806 17.2924L12.0006 23.5862L27.2931 8.29245C27.4807 8.1048 27.7352 7.99939 28.0006 7.99939C28.2659 7.99939 28.5204 8.1048 28.7081 8.29245C28.8957 8.48009 29.0011 8.73458 29.0011 8.99995C29.0011 9.26531 28.8957 9.51981 28.7081 9.70745Z",
    fill: "currentColor"
  })));
};
export default SvgCheck;